import Temas from '@/widgets/Listado/Templates/Temas'; 
import { useState, useEffect } from 'react';
import styles from './styles.module.css';
import Head from 'next/head'
import Header from '@/shared/components/Header';
import Footer from '@/shared/components/Footer';
import ContenedorTitulo from '@/shared/components/ContenedorTitulo';
import { useAppContext } from '@pagegrowler_nextjs';
import Chartbeat from '@/shared/components/Chartbeat';
import Templates from "@/widgets/index";

const Tags = (props) => {
    const LOAD_MORE = 20;

    const { 
      content,		
      pagination = {} 
    } = { ...props };

    const description = `Temas de Noticias del diario El Litoral- Noticias actualizadas las 24hs.`;
    
    const [open, setOpen] = useState(false);
    let menues = props.menu ? props.menu : [];

    let [data, setData] = useState([]);
    let [offset, setOffset] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [hideLoadMore, setHideLoadMore] = useState(false);
  
    const pg = useAppContext();
    const Pagegrowler = pg.pagegrowler;

    async function showMoreData() {
      setIsLoading(true);
      let res = await Pagegrowler.loadMoreData(LOAD_MORE, offset);
      if (res.content && res.content.length > 0){
        setData(prevState => [...prevState, ...res.content]);
        setOffset(offset + LOAD_MORE);
        setIsLoading(false);
      } else {
        setHideLoadMore(true);
      }
    }

    useEffect(() => {
      setOffset(pagination.limit + pagination.offset);
      setData(content);
    }, []);
    let dataLDJson =  {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Diario El Litoral",
      "url": "https://www.ellitoral.com",
      "logo": {
        "@type": "ImageObject",
        "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
        "width": 439,
        "height": 60
      },
      "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://plus.google.com/+EllitoralArgentina"]
    };
    return(
        <>
        <Head>
          <title>Temas - El Litoral</title>
          <meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
          <meta name="description" content={description} />
          <meta httpEquiv="refresh" content="600" />
          <meta name="og:description" property="og:description" content={description} />
          <link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />    
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(dataLDJson) }} />
          <link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + '/temas/' } />
        </Head>
        <Chartbeat/>
        <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
        <div className={`${styles["parent"]}`}>
          <div className={styles["container"]}>
            {!props.preview && <Templates.BannerHorizontalChico bannerId={`top`} />}
            <ContenedorTitulo text='Temas'/>
            <Temas tags={data} />
            <div className={styles["button-container"]}>
              <button className={`${styles["button"]} ${styles[hideLoadMore? 'hide': '']}`} disabled={isLoading} onClick={showMoreData}>
                Cargar más temas
              </button>
            </div>
          </div>

          {!props.preview && <Templates.BannerHorizontalChico bannerId={`horizontal1`} />}
        </div>
        <div style={{ clear: "both" }}>
          <Footer />
        </div>
      </>
    )
}

export default Tags;